import { useCallback, useEffect, useMemo, useState } from 'react';
import { graphQL } from 'javascripts/shared/graphql';

export function usePaginatedGraphQL({ query, data = {}, currentPage, queryName }) {
  const [canFetchMore, setCanFetchMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [objects, setObjects] = useState([]);
  const [count, setCount] = useState(0);

  const memoizedData = useMemo(
    () => data,
    Object.values(data).map(item => JSON.stringify(item)),
  );

  const fetchData = useCallback(() => {
    graphQL
      .get(query, _.merge({}, data, { page: currentPage }))
      .then(response => {
        const { totalCount, objects: newObjects } = _.get(response, queryName, { totalCount: 0, objects: [] });
        const updatedObjects = currentPage === 1 ? newObjects : [...objects, ...newObjects];
        setObjects(updatedObjects);
        setCanFetchMore(_.size(updatedObjects) < totalCount);
        setCount(totalCount);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        throw error;
      });
  }, [currentPage, memoizedData, query]);

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [fetchData]);

  return {
    canFetchMore,
    loading,
    forceRefreshData: fetchData,
    objects,
    totalCount: count,
  };
}
